import { useState, useEffect, useCallback } from 'react';
import { authService, type AuthState } from '../services/auth';

export interface UseAuthReturn extends AuthState {
  login: () => void;
  logout: () => Promise<void>;
  refresh: () => Promise<void>;
}

export function useAuth(): UseAuthReturn {
  const [state, setState] = useState<AuthState>({
    user: null,
    loading: true,
    error: null,
  });

  // Check auth status on mount
  useEffect(() => {
    const checkAuth = async () => {
      try {
        const user = await authService.me();
        setState({ user, loading: false, error: null });
      } catch {
        setState({ user: null, loading: false, error: null });
      }
    };

    checkAuth();
  }, []);

  const login = useCallback(() => {
    authService.initiateSSO();
  }, []);

  const logout = useCallback(async () => {
    await authService.logout(false); // Don't redirect to DSAccount by default
    setState({ user: null, loading: false, error: null });
  }, []);

  const refresh = useCallback(async () => {
    try {
      await authService.refreshSession();
    } catch (err) {
      console.error('Failed to refresh session:', err);
    }
  }, []);

  return {
    ...state,
    login,
    logout,
    refresh,
  };
}

export default useAuth;
